import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";

export function useReturningUsers(fromDate: string, toDate: string) {
  return useQuery({
    queryKey: ["platformAnalytics", "returningUsers", fromDate, toDate],
    queryFn: () =>
      api.getReturningUsers({ from_date: fromDate, to_date: toDate }),
  });
}
